<!-- Department header -->
<app-dept-header *ngIf="deptId != undefined"></app-dept-header>
<!-- Department header -->
<!-- Page Content -->

<div id="page-content">
  <div class="lec-wrapper staff-profile-top">
    <div class="container">
      <div class="row">
        <!--MAIN Content-->
        <div class="col-md-8">
          <div id="page-main">

            <!--CSS Loader-->
            <section *ngIf="staffLoader">
              <div class="ph-item phitem-color">
                <div class="ph-col-4">
                  <div class="ph-picture"></div>
                </div>

                <div>
                  <div class="ph-row">
                    <div class="ph-col-6"></div>
                    <div class="ph-col-6 empty"></div>
                    <br><br>
                    <div class="ph-col-2"></div>
                    <div class="ph-col-10 empty"></div>
                    <div class="ph-col-8"></div>
                    <div class="ph-col-4 empty"></div>
                    <br><br>
                    <div class="ph-col-6"></div>
                    <div class="ph-col-6 empty"></div>
                    <div class="ph-col-8"></div>
                    <div class="ph-col-4 empty"></div>
                    <br><br>
                    <div class="ph-col-4"></div>
                    <div class="ph-col-8 empty"></div>
                    <div class="ph-col-6"></div>
                    <div class="ph-col-6 empty"></div>
                  </div>
                </div>
              </div>
            </section>
            <!--CSS Loader-->

            <section id="members">
              <header><h1>{{member?.title}}. {{member?.full_name}}</h1></header>
              <div class="author-block member-detail">
                <figure class="author-picture"><img src="{{member?.user?.profile_image}}" alt="{{member?.full_name}}"></figure>
                <article class="paragraph-wrapper">
                  <div class="inner">

                    <div *ngFor="let desig of member?.staff_vs_desigs">
                      <header><h3 class="lec-desig">{{desig.staff_desig.designation}}</h3></header>
                    </div>
                    <hr>
                    <p class="quote">
<!--                      <span *ngIf="member?.user?.mobile_number != 'null'">{{member?.user?.mobile_number}}</span>-->
                      <span *ngIf="member?.contact != 'null'">{{member?.contact}}</span>
                      <br>
                      <span *ngIf="member?.user?.email != 'null'">{{member?.user?.email}}</span>
                      <br>
                      <span *ngIf="member?.second_email != 'null'">{{member?.second_email}}</span>

                    </p>
                    <hr>
                    <div class="contact">
                      <div *ngIf="links.length != 0">
<!--                        <p>Professional profiles</p>-->
                      </div>
  <!--                    <div class="icons">-->
  <!--                      <a href=""><i class="fa fa-facebook"></i></a>-->
  <!--                    </div>&lt;!&ndash; /.icons &ndash;&gt;-->
  <!--                    <h2>Divisions</h2>-->

                      <div class="section-content">
                        <ul class="list-links">
                          <li class="links-list" *ngFor="let link of links">
                            <a [href]="link.link_url" target="_blank">
                              {{link.link_type.type}}
                            </a></li>
                        </ul>
                      </div><!-- /.section-content -->

                    </div>

                  </div>

                </article>
              </div><!-- /.author -->
            </section>
          </div><!-- /#page-main -->
        </div><!-- /.col-md-8 -->

        <!--SIDEBAR Content-->
        <div class="col-md-4">
          <div id="page-sidebar" class="sidebar">

            <aside class="news-small" id="news-small">
              <br><br>
              <p>
                {{member?.title}}. {{member?.full_name}},<br>
                {{member?.department?.dept_name}} - {{member?.department?.code}}<br>
                {{member?.faculty?.faculty_name}},<br>
                {{member?.department?.add_line1}},<br>
                {{member?.department?.add_line2}},<br>
                {{member?.department?.city}}, {{member?.department?.country}}<br>
                {{member?.department?.postal_code}},<br><br>
                Tel : {{member?.department?.phone}} | {{member?.department?.extensions}}<br>
                <span *ngIf="member?.department?.fax != 'null'">Fax : {{member?.department?.fax}}</span>
              </p>

            </aside><!-- /.news-small -->

          </div><!-- /#sidebar -->
        </div><!-- /.col-md-4 -->
      </div><!-- /.row -->
    </div>
  </div>
  <div class="container">

<!--Specialities - Biography-->
    <div class="row">
      <div class="col-md-12">
        <section *ngFor="let spec_type of specialities.slice(0,1)">
          <header>
            <h4>{{spec_type.specialty_name}}</h4>
          </header>
          <ul>
            <span *ngFor="let spec1 of spec_type.specialty">
              <div class="content-view" [innerHTML]="spec1.description"></div>
            </span>
          </ul>
        </section>
      </div>
    </div><!-- /.row -->

    <div class="row">
      <div class="col-md-12 speciality-card" *ngFor="let spec_type of specialities.slice(1,100)">
        <div class="card">
          <div class="card-body speciality-card-color">
            <h5 class="card-title">{{spec_type.specialty_name}}</h5>
            <span class="card-text" *ngFor="let spec of spec_type.specialty">
              <div [innerHTML]="spec.description"></div>
            </span>
          </div>
        </div>
      </div>
    </div>
    <hr>
<!--publications-->
    <div class="row">
      <div class="col-md-12">
          <h4 *ngIf="publications.length != 0">Publications</h4>
        <section id="right-sidebar" *ngFor="let type of publications">
          <header>
            <h4>{{type.type_name}}</h4>
          </header>

          <section class="events" id="events">
            <div class="section-content">
              <article class="event" *ngFor="let pub of type.publications let i=index">

                <span *ngIf="pub.external_link !== null">
                  <a href="{{pub.external_link}}" target="_blank">
                    <figure class="date date-color-active">
                      <div class="month">{{ pub.year }}</div>
                    </figure>
                  </a>
                </span>

                <span *ngIf="pub.external_link === null">
                    <figure class="date date-color-inactive">
                      <div class="month">{{ pub.year }}</div>
                    </figure>
                </span>

                <aside>
                  <div [innerHTML]="pub.citation"></div>
                </aside>

              </article><!-- /article -->
            </div><!-- /.section-content -->
          </section>

        </section>
      </div>
    </div><!-- /.row -->

  </div><!-- /.container -->
</div>
<!-- end Page Content -->
